import React, { useEffect, useState, useRef } from "react";
import ImageGreenArrow from "../../images/round-green-right-arrow.svg";
import { Link, graphql, useStaticQuery, navigate } from "gatsby";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import DefaultIcon from '../../icons/icon-executive.svg';
import InView from "react-intersection-observer";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import LazyLoad from 'react-lazyload';

const CareerMission = () => {

  const [isMobile, setisMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  
  const tabRef = [useRef(), useRef(), useRef(), useRef(), useRef()];
  const data = useStaticQuery(graphql`
  query MyCareerQuery {
    allWordpressWpCareer {
      edges {
        node {
          slug
          title
          id
          job_location
          career_category
          acf {
            icon{
              source_url
            }
            icon_path
            job_type 
            job_location
          }
          job_type
        }
      }
      totalCount
    }
    allWordpressWpCareerCategory {
      edges {
        node {
          slug
          name
          id
          wordpress_id
          _links {
            self {
              href
            }
          }
        }
      }
    }
  }`);

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });

    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });

  const tabHandle = (id) => {
    if (isMobile) {
      tabRef[id].current.node.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }
  };

  let design = 0, engineering = 0, operations = 0, sales = 0;

  data.allWordpressWpCareer.edges.map((job, i) => {
    if (job.node.career_category[0] === 145) {
      design++;
    } else if (job.node.career_category[0] === 146) {
      engineering++;
    } else if (job.node.career_category[0] === 150) {
      sales++;
    } else if (job.node.career_category[0] === 147) {
      operations++;
    }
  });

  return (
    <InView as="div" onChange={inView => setIsVisible(inView)} className="career-mission-section section-gap" id="openings">
      <div className="container">
        <div className="how-it-works section-gap grid" data-isotope='{ "itemSelector": ".grid-item", "layoutMode": "fitRows" }'>
          <p className="theme-color-title">{isVisible && <HeaderAnim header="JOIN OUR TEAM" />}</p>
          <h2 className="h3">Interested in working with us? Check out these opportunities.</h2>
          <Tabs>
            <TabList>
              <Tab ref={tabRef[0]} onClick={() => tabHandle(0)}>All <sup>{design + engineering + operations + sales}</sup></Tab>
              <Tab ref={tabRef[1]} onClick={() => tabHandle(1)}>Design <sup>{design}</sup></Tab>
              <Tab ref={tabRef[2]} onClick={() => tabHandle(2)}>Engineering <sup>{engineering}</sup></Tab>
              <Tab ref={tabRef[3]} onClick={() => tabHandle(3)}> Sales & Marketing <sup>{sales}</sup></Tab>
              <Tab ref={tabRef[4]} onClick={() => tabHandle(4)}>Operations <sup>{operations}</sup></Tab>
            </TabList>
            <TabPanel>
              <ul className="work-list">
                {data.allWordpressWpCareer.edges.map((job, i) => {
                  return <li key={i} className="work-item grid-item">
                    {/* <div className="work-image"><img src={job.node.acf.icon_path ? job.node.acf.icon_path : (job.node.acf.icon ? job.node.acf.icon.source_url : "")} /></div> */}
                    <div className="work-image">{job.node.acf.icon ? <LazyLoad><img src={job.node.acf.icon.source_url.replace(/testingsite01.rapidops/g, 'mk0rapidopsback40h4t.kinstacdn')} /></LazyLoad> : <DefaultIcon />}</div>
                    <div className="work-content">
                      <h3><Link href={"/careers/" + job.node.slug + '/'} target="_blank" >{job.node.title}</Link></h3>
                      <p>{job.node.job_type + ", " + job.node.job_location}</p>
                      <Link href={"/careers/" + job.node.slug + '/'} target="_blank" className="work-link" ><LazyLoad><img src={ImageGreenArrow} alt="Mission" /></LazyLoad></Link>
                    </div>
                  </li>;
                })
                }
              </ul>
            </TabPanel>
            <TabPanel>
              <ul className="work-list">
                {data.allWordpressWpCareer.edges.map((job, i) => {
                  if (job.node.career_category[0] === 145) {
                    return <li key={i} className="work-item grid-item">
                      {/* <div className="work-image"><img src={job.node.acf.icon_path ? job.node.acf.icon_path : (job.node.acf.icon ? job.node.acf.icon.source_url : "")} /></div> */}
                      <div className="work-image">{job.node.acf.icon ? <LazyLoad><img src={job.node.acf.icon.source_url} /></LazyLoad> : <DefaultIcon />}</div>
                      <div className="work-content">
                        <h3><Link to={"/careers/" + job.node.slug + '/'} target="_blank">{job.node.title}</Link></h3>
                        <p>{job.node.job_type + ", " + job.node.job_location}</p>
                        <Link to={"/careers/" + job.node.slug + '/'} target="_blank" className="work-link"><LazyLoad><img src={ImageGreenArrow} alt="Mission" /></LazyLoad></Link>
                      </div>
                    </li>;
                  }
                })
                }
              </ul>
            </TabPanel>
            <TabPanel>
              <ul className="work-list">
                {data.allWordpressWpCareer.edges.map((job, i) => {
                  if (job.node.career_category[0] === 146) {
                    return <li key={i} className="work-item grid-item">
                      {/* <div className="work-image"><img src={job.node.acf.icon_path ? job.node.acf.icon_path : (job.node.acf.icon ? job.node.acf.icon.source_url : "")} /></div> */}
                      <div className="work-image">{job.node.acf.icon ? <LazyLoad><img src={job.node.acf.icon.source_url} /></LazyLoad> : <DefaultIcon />}</div>
                      <div className="work-content">
                        <h3><Link to={"/careers/" + job.node.slug + '/'} target="_blank">{job.node.title}</Link></h3>
                        <p>{job.node.job_type + ", " + job.node.job_location}</p>
                        <Link to={"/careers/" + job.node.slug + '/'} target="_blank" className="work-link"><LazyLoad><img src={ImageGreenArrow} alt="Mission" /></LazyLoad></Link>
                      </div>
                    </li>;
                  }
                })
                }
              </ul>
            </TabPanel>
            <TabPanel>
              <ul className="work-list">
                {data.allWordpressWpCareer.edges.map((job, i) => {
                  if (job.node.career_category[0] === 150) {
                    return <li key={i} className="work-item grid-item">
                      {/* <div className="work-image"><img src={job.node.acf.icon_path ? job.node.acf.icon_path : (job.node.acf.icon ? job.node.acf.icon.source_url : "")} /></div> */}
                      <div className="work-image">{job.node.acf.icon ? <LazyLoad><img src={job.node.acf.icon.source_url} /></LazyLoad> : <DefaultIcon />}</div>
                      <div className="work-content">
                        <h3><Link to={"/careers/" + job.node.slug + '/'} target="_blank">{job.node.title}</Link></h3>
                        <p>{job.node.job_type + ", " + job.node.job_location}</p>
                        <Link to={"/careers/" + job.node.slug + '/'} target="_blank" className="work-link"><LazyLoad><img src={ImageGreenArrow} alt="Mission" /></LazyLoad></Link>
                      </div>
                    </li>;
                  }
                })
                }
              </ul>
            </TabPanel>
            <TabPanel>
              <ul className="work-list">
                {data.allWordpressWpCareer.edges.map((job, i) => {
                  if (job.node.career_category[0] === 147) {
                    return <li key={i} className="work-item grid-item">
                      {/* <div className="work-image"><img src={job.node.acf.icon_path ? job.node.acf.icon_path : (job.node.acf.icon ? job.node.acf.icon.source_url : "")} /></div> */}
                      <div className="work-image">{job.node.acf.icon ? <LazyLoad><img src={job.node.acf.icon.source_url} /></LazyLoad> : <DefaultIcon />}</div>
                      <div className="work-content">
                        <h3><Link to={"/careers/" + job.node.slug + '/'} target="_blank">{job.node.title}</Link></h3>
                        <p>{job.node.job_type + ", " + job.node.job_location}</p>
                        <Link to={"/careers/" + job.node.slug + '/'} target="_blank" className="work-link"><LazyLoad><img src={ImageGreenArrow} alt="Mission" /></LazyLoad></Link>
                      </div>
                    </li>;
                  }
                })
                }
              </ul>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </InView>
  );
};

export default CareerMission;
